module.exports = __webpack_public_path__ + "static/media/Keldeo_gaussian2.4b77ba46.png";